import { t } from "@/game/i18n";
import { useEffect, useState } from "react";
import { Trophy } from "lucide-react";
import { ScoreEntry, fetchTopScores } from "@/game/api";

export const Leaderboard = ({ highlightId, refreshKey = 0 }: { highlightId?: string; refreshKey?: number }) => {
  const [rows, setRows] = useState<ScoreEntry[] | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    setError(false);
    fetchTopScores().then(setRows).catch(() => setError(true));
  }, [refreshKey]);

  return (
    <div data-testid="leaderboard" className="w-full">
      <div className="flex items-center gap-2 mb-3">
        <Trophy size={16} className="text-amber-400" />
        <span className="eyebrow">Top 10 · online</span>
      </div>
      {error && <div data-testid="leaderboard-error" className="text-sm text-red-400">Leaderboard trenutno nije dostupan.</div>}
      {!error && rows === null && <div data-testid="leaderboard-loading" className="text-sm text-stone-500">{t("loading")}</div>}
      {rows && rows.length === 0 && <div data-testid="leaderboard-empty" className="text-sm text-stone-500">{t("noScores")}</div>}
      {rows && rows.length > 0 && (
        <ol data-testid="leaderboard-list" className="space-y-1">
          {rows.map((r, i) => (
            <li
              key={r.id}
              data-testid={`leaderboard-row-${i + 1}`}
              className={`flex items-center gap-3 px-3 py-1.5 rounded-lg text-sm ${r.id === highlightId ? "bg-amber-500/25 ring-2 ring-amber-400 text-amber-100" : "bg-white/[0.03]"}`}
            >
              <span className="font-mono text-amber-400/80 w-5 text-right">{i + 1}</span>
              <span className="flex-1 truncate font-semibold text-stone-200">{r.name}</span>
              <span className="text-xs text-stone-500">{t("packLvl")} {r.level}</span>
              <span className="font-mono font-bold text-amber-300">{r.score}</span>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
};
